import {environmentSecret} from "@enviroment/environment.secret";

export const environment = {
  production: false,
  allowed_token_domain: 'dev.recetamedica.digital',
  backend_url: 'https://dev.recetamedica.digital/api/',
  token_name: 'receta-medica-digital-token',
  cypher_key: 'receta-medica-digital-key',
  encryptionKey: environmentSecret.encryptionKey,
  user_data: 'user_data',
  region: 'MX', // o el pais/codigo que uses
  noticiasEnabled: false,
  twoFAEnabled: true,
  showHipFeatures: false
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
